import { Model, modelRegistry } from './Model';
import { Product } from '.';
import HashGen from '../utilities/HashGen';
import Money from '../utilities/Money';
import { I18n } from '../wrappers/I18n';
export class PriceLevelingItem extends Model {
    static entity = 'price_leveling_items';
    id = null;
    price_leveling_id = null;
    date = null;
    product_id = null;
    unit_of_measure = null;
    tax_rate = '0.00';
    quantity = '1.000';
    old_selling_price = '0.0000';
    old_selling_price_after_tax = '0.0000';
    selling_price = '0.0000';
    selling_price_after_tax = '0.0000';
    recorded_at = null;
    created_at = null;
    updated_at = null;
    hash = '';
    static fields() {
        return {
            id: this.attr(null),
            price_leveling_id: this.attr(null),
            date: this.attr(null),
            product_id: this.attr(null),
            unit_of_measure: this.attr(null),
            tax_rate: this.attr('0.00', value => this.round(value, 2).toFixed(2)),
            quantity: this.attr('1.000', value => this.round(value, 3).toFixed(3)),
            old_selling_price: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            old_selling_price_after_tax: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            selling_price: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            selling_price_after_tax: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            recorded_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            hash: this.attr(HashGen.regular()),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getTaxRate() {
        return parseFloat(this.tax_rate);
    }
    getQuantity() {
        return parseFloat(this.quantity);
    }
    getOldSellingPrice() {
        return Money.parse(this.old_selling_price);
    }
    getOldSellingPriceAfterTax() {
        return Money.parse(this.old_selling_price_after_tax);
    }
    getSellingPrice() {
        return Money.parse(this.selling_price);
    }
    getSellingPriceAfterTax() {
        return Money.parse(this.selling_price_after_tax);
    }
    getOldSellingValue() {
        const value = this.getOldSellingPrice()
            .multiply(this.getQuantity());
        return Money.parse(value.toFormat('0.0000'));
    }
    getOldTax() {
        const value = this.getOldSellingValue()
            .multiply(this.getTaxRate() / 100);
        return Money.parse(value.toFormat('0.0000'));
    }
    getOldSellingValueAfterTax() {
        const value = this.getOldSellingValue()
            .add(this.getOldTax());
        return Money.parse(value.toFormat('0.0000'));
    }
    getSellingValue() {
        const value = this.getSellingPrice()
            .multiply(this.getQuantity());
        return Money.parse(value.toFormat('0.0000'));
    }
    getTax() {
        const value = this.getSellingValue()
            .multiply(this.getTaxRate() / 100);
        return Money.parse(value.toFormat('0.0000'));
    }
    getSellingValueAfterTax() {
        const value = this.getSellingValue()
            .add(this.getTax());
        return Money.parse(value.toFormat('0.0000'));
    }
    getPriceDifference() {
        return this.getSellingValue()
            .subtract(this.getOldSellingValue());
    }
    getPriceDifferencePerUnit() {
        const value = this.getQuantity() != 0
            ? this.getPriceDifference()
                .divide(this.getQuantity())
            : Money.parse(0);
        return Money.parse(value.toFormat('0.0000'));
    }
    getProduct() {
        return Product.find(this.product_id);
    }
    getUnitOfMeasure() {
        return I18n.t(`products.unit_of_measure.${this.unit_of_measure}`) !== `products.unit_of_measure.${this.unit_of_measure}`
            ? I18n.t(`products.unit_of_measure.${this.unit_of_measure}`)
            : this.unit_of_measure;
    }
    calculatePrices(value, baseField) {
        let sellingPrice = Money.parse(0);
        let sellingPriceAfterTax = Money.parse(0);
        if (baseField === 'selling_price') {
            sellingPrice = Money.parse(this.round(value, 4));
            sellingPriceAfterTax = Money.parse(sellingPrice.toUnit())
                .multiply(1 + this.getTaxRate() / 100);
        }
        else if (baseField === 'selling_price_after_tax') {
            sellingPriceAfterTax = Money.parse(this.round(value, 4));
            sellingPrice = Money.parse(sellingPriceAfterTax.toUnit())
                .divide(1 + this.getTaxRate() / 100);
        }
        return {
            selling_price: sellingPrice.toFormat('0.0000'),
            selling_price_after_tax: sellingPriceAfterTax.toFormat('0.0000'),
        };
    }
}
export default PriceLevelingItem;
modelRegistry.register('PriceLevelingItem', PriceLevelingItem);
//# sourceMappingURL=PriceLevelingItem.js.map